export default __webpack_public_path__ + "static/media/amazon-cloud-bg.61760db7.jpg";